export class UserPasswordReset {
  // variables

  emailAddress: string;
  password: string;
  passwordConfirm: string;
  passwordResetKey: string;
  recaptchaResponse: string;
}
